import { getAccountId, userIsNotLoggedIn } from '../../core/pure/Window'
import { ConsentCheckboxList } from './components/ConsentCheckboxListProvider'

export const MySettings: React.FC = () => {
  if (userIsNotLoggedIn()) return null

  // Check for accountId in window object & opt out when no value
  const loggedInUserAccountId = getAccountId()
  if (!loggedInUserAccountId) {
    throw new Error('There is no accountId present inside: window.MEDIAHUIS?.user?.accountId')
  }

  return <ConsentCheckboxList accountId={loggedInUserAccountId} />
}
